import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from '@nk/ui-lib';

@Component({
  selector: 'nk-company-analysis-risk-loading',
  imports: [TranslateModule, SpinnerComponent],
  templateUrl: './company-analysis-risk-loading.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyAnalysisRiskLoadingComponent {
  public text = input<string>('');
}
